import React from 'react'
import styles from './MicrositeSlider.module.css'

/**
 * MicrositeSlider
 * Range slider with min/max/step and a live numeric readout.
 * Used for SEO priority (0.0–1.0) and sitemap default priority.
 *
 * Usage:
 *   <MicrositeSlider
 *     label="Priority"
 *     value={form.priority}
 *     onChange={(v) => updateField('priority', v)}
 *     min={0} max={1} step={0.1}
 *   />
 */
const MicrositeSlider = ({
    label,
    value,
    onChange,
    min = 0,
    max = 1,
    step = 0.1,
    helperText
}) => (
    <div className={styles.field}>
        {label && (
            <div className={styles.labelRow}>
                <label className={styles.label}>{label}</label>
                <span className={styles.value}>{Number(value).toFixed(1)}</span>
            </div>
        )}
        <input
            type="range"
            className={styles.slider}
            min={min}
            max={max}
            step={step}
            value={value ?? min}
            onChange={(e) => onChange?.(parseFloat(e.target.value))}
        />
        {helperText && <div className={styles.helperText}>{helperText}</div>}
    </div>
)

export default MicrositeSlider